import TimeMixin from '@/mixins/Time.js'
import SizesMixin from '@/mixins/Sizes.js'
import ScrollMixin from '@/mixins/Scroll.js'

import AppPicture from '@/components/app-picture'
import AppVideo from '@/components/app-video'

export default
{
    name: 'app-player-simple',

    mixins:
    [
        TimeMixin,
        ScrollMixin,
        SizesMixin
    ],

    components:
    {
        AppPicture,
        AppVideo
    },

    props:
    {
        content: { type: Object, default()
        {
            return {}
        } }
    },

    data()
    {
        return {
            shouldPlay: true,
            playing: false,
            playedOnce: false,
            progress: 0,
            onScreen: false,
            videoWidth: 800,
            videoHeight: 600
        }
    },

    watch:
    {
        onScreen()
        {
            if(this.onScreen)
            {
                if(this.shouldPlay)
                {
                    this.$video.play()
                }
            }
            else
            {
                this.$video.pause()
            }
        }
    },

    mounted()
    {
        this.measures = {}
        this.measures.top = 0
        this.measures.width = 0
        this.measures.height = 0

        this.$video = this.$refs.video

        this.$video.$on('play', () =>
        {
            this.playing = true

            if(!this.playedOnce)
            {
                this.playedOnce = true
            }
        })

        this.$video.$on('pause', () =>
        {
            this.playing = false
        })

        this.$video.$on('time-change', ($video) =>
        {
            this.progress = $video.currentTime / $video.duration
        })

        this.$nextTick(() =>
        {
            this.onResize()
        })
    },

    methods:
    {
        onResize()
        {
            const bounding = this.$el.getBoundingClientRect()
            this.measures.top = bounding.top + this.scroll.current
            this.measures.width = bounding.width
            this.measures.height = bounding.height

            this.testOnScreen()
            this.updateSizes()
        },

        onScroll()
        {
            this.testOnScreen()
        },

        testOnScreen()
        {
            this.onScreen = this.scroll.current > this.measures.top - this.sizes.height && this.scroll.current < this.measures.top + this.measures.height
        },

        updateSizes()
        {
            const ratio = this.content.videos[0].width / this.content.videos[0].height
            let height = this.measures.width / ratio
            let width = this.measures.width

            if(height > this.sizes.viewport.height * 0.8)
            {
                height = this.sizes.viewport.height * 0.8
                width = height * ratio
            }

            this.videoWidth = Math.round(width)
            this.videoHeight = Math.round(height)
        },

        onToggleClick()
        {
            // Video is paused
            if(this.$video.$video.paused)
            {
                // Play video and save that the video should play
                this.$video.play()
                this.shouldPlay = true
            }

            // Video is playing
            else
            {
                // Pause video and save that the video should stay paused
                this.$video.pause()
                this.shouldPlay = false
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-player-simple/script.js